// @ts-nocheck

import { createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';
import _merge from 'lodash/merge';

import { authApi } from '../lib/api';

export type WialonStoreState = {
  accessToken: string | null;
  [key: string]: unknown;
};

const initialState: WialonStoreState = {
  accessToken: null
};

const wialonStoreSlice = createSlice({
  name: 'vehicles/wialonStore',
  initialState,
  reducers: {
    setStore: (
      state,
      { payload }: { payload: Partial<WialonStoreState> }
    ) => _merge({}, state, payload),
    fetchWialonToken: (state, { payload }: { payload: string | null }) => ({
      ...state,
      accessToken: payload
    }),
  }
});

export const wialonStoreActions = wialonStoreSlice.actions;

export const setStore = (value: Partial<WialonStoreState>) => (
  dispatch: Dispatch
) => dispatch(wialonStoreActions.setStore(value));

export const fetchWialonToken = () => async (dispatch: Dispatch) => {
  const wialonToken = await authApi.getWialonToken();
  dispatch(wialonStoreActions.fetchWialonToken(wialonToken));
};

export default wialonStoreSlice.reducer;
